import "../../../../NodeTypes/index";
window.addEventListener("DOMContentLoaded", () => {
  window.dispatchEvent(new Event("resize"));
});